export default __webpack_public_path__ + "static/media/farooq_1.1abbba85.jpg";